// The api-maker base model and the generated models form a circular dependency:
// the models index must start initializing the circle, or the generated models
// would extend a not-yet-defined base model.
import "models.js"
import "controllers"
import {BrowserRouter, useRoutes} from "react-router-dom"
import React, {Suspense} from "react"
import {App} from "components/app"
import {CanCanApp} from "shared/can-can-app"
import {createRoot} from "react-dom/client"
import FlashMessages from "nemoa/components/flash-messages"
import {readRoutes} from "shared/resource-routes"
import ScrollToTop from "shared/scroll-to-top"

require("stylesheets/application")
require("stylesheets/contained-image")
require("shared/devise")
require("shared/error-logger")
require("shared/i18n")

// Lazy components must have stable identity across renders: with
// concurrent rendering (createRoot), a React.lazy created inside render
// (e.g. in a useMemo) is recreated on every suspend/retry cycle, which
// re-suspends forever because each new instance starts a fresh import.
const lazyRouteComponents = new Map()

const requireComponent = (component) => {
  if (!lazyRouteComponents.has(component)) {
    lazyRouteComponents.set(component, React.lazy(() => import(/* webpackChunkName: "[request]" */ `nemoa/routes/${component}`)))
  }

  return lazyRouteComponents.get(component)
}

function RouteDefinitions() {
  const routes = readRoutes({
    requireComponent,
    routeDefinitions: require("nemoa/route-definitions.json")
  })

  const element = useRoutes(routes)

  return element
}

document.addEventListener("DOMContentLoaded", () => {
  const reactRoot = document.querySelector(".react-root")

  createRoot(reactRoot).render((
    <BrowserRouter>
      <App>
        <ScrollToTop />
        <FlashMessages />
        <Suspense fallback={<div />}>
          <CanCanApp abilities={[["admin", ["access"]]]}>
            <RouteDefinitions />
          </CanCanApp>
        </Suspense>
      </App>
    </BrowserRouter>
  ))
})
